
import Vue from 'vue'

const dayParam = (day) => ({params: {date: day}})

export default (realPlanId, day) =>  {
	let url = 'workplan/assistence/'

	if (realPlanId) {
		url += `plan_real/${realPlanId}/`
	}

	const config = day ? dayParam(day) : null

	return Vue.$http.get(url, config)
		.then(response => response.data)
}




// WEBPACK FOOTER //
// ./src/services/workPlan/fetchAssistance.js